<template>
  <fin-data-loader :resolver="loadPortfolio">
    <template #content>
      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   class="pt-3"
                   fluid>
        <v-row>
          <v-col cols="12">
            <fin-portfolio-backtesting :portfolio-data="portfolio" v-if="portfolio"/>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import FinPortfolioBacktesting from "@/components/pages/myPortfolio/PortfolioBacktesting"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getStrategySamplePortfolioId} from "@/components/pages/finStrategy/details/tabs/backtesting/graphql"

export default {
  name: "finStrategyDetailsBacktesting",
  components: {FinPortfolioBacktesting, FinDataLoader},
  props: {
    strategyId: {
      type: String
    },
  },
  data() {
    return {
      portfolio: undefined
    }
  },
  methods: {
    async loadPortfolio() {
      const result = await API.graphql(graphqlOperation(getStrategySamplePortfolioId, {
        strategyId: this.strategyId
      }))

      if (result) {
        this.portfolio = result.data.getStrategySamplePortfolio
      }
    }
  }
}
</script>
